/** Hosts that send X-Frame-Options: SAMEORIGIN, so a cross-origin iframe stays blank. */
const TOP_LEVEL_ONLY_HOSTS = new Set(['static.edusign.com'])

export function signingUrlRequiresTopLevel(url: string): boolean {
  try {
    return TOP_LEVEL_ONLY_HOSTS.has(new URL(url).hostname)
  } catch {
    return false
  }
}
